/**
 * Quantity selector component
 * 
 * @module quantity-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'quantity-selector';

if (!customElements.get(customElements.component)) {

    class QuantitySelector extends HTMLElement {

        /**
         * Quantity selector web component
         * 
         * @constructor
         */
        constructor() {

            super();

            window.theme.quantity_selector = this; 

            this.initEvents();

        }
        
        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            this.querySelector('[data-quantity-selector-minus]').addEventListener('click', event => {

                event.preventDefault();

                let input = event.target.parentElement.querySelector('input');

                this.decrease(input);
            });

            this.querySelector('[data-quantity-selector-plus]').addEventListener('click', event => {

                event.preventDefault();

                let input = event.target.parentElement.querySelector('input');

                this.increase(input);
            });

        }

        /**
         * Decrease input value
         * 
         * @param {input} input A input for the quantity selector.
         */

        decrease(input) {

            let value = parseInt(input.value);

            if (value > 0) {

                value--;

                input.value = value;

                let event = new CustomEvent('change', {'detail': input });

                input.dispatchEvent(event);
            }
        }

        /**
         * Increase input value
         * 
         * @param {input} input A input for the quantity selector.
         */

        increase(input) {

            let value = parseInt(input.value);

            value++;

            input.value = value;

            let event = new CustomEvent('change', {'detail': input });
                
            input.dispatchEvent(event);
        }

        
    }

    customElements.define(customElements.component, QuantitySelector);
}
